import { profileService } from 'src/modules/profile/services';

export const loadRegistred = () => {
  profileService.loadRegistered();
};
